import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function H2Icon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <path
        xmlns="http://www.w3.org/2000/svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.75 7C6.16421 7 6.5 7.33579 6.5 7.75V11.5H10.5V7.75C10.5 7.33579 10.8358 7 11.25 7C11.6642 7 12 7.33579 12 7.75V16.25C12 16.6642 11.6642 17 11.25 17C10.8358 17 10.5 16.6642 10.5 16.25V13H6.5V16.25C6.5 16.6642 6.16421 17 5.75 17C5.33579 17 5 16.6642 5 16.25V7.75C5 7.33579 5.33579 7 5.75 7ZM14.7322 7.73223C15.2011 7.26339 15.837 7 16.5 7C17.163 7 17.7989 7.26339 18.2678 7.73223C18.7366 8.20107 19 8.83696 19 9.5V9.975C18.9999 10.6126 18.7783 11.2305 18.373 11.7227L15.785 14.8647C15.6348 15.0472 15.54 15.2677 15.5102 15.5H18.25C18.6642 15.5 19 15.8358 19 16.25C19 16.6642 18.6642 17 18.25 17H14.75C14.3358 17 14 16.6642 14 16.25V15.6603C13.9998 15.0223 14.2215 14.4038 14.627 13.9113L17.215 10.7693C17.3992 10.5456 17.4999 10.2648 17.5 9.975V9.5C17.5 9.23478 17.3946 8.98043 17.2071 8.79289C17.0196 8.60536 16.7652 8.5 16.5 8.5C16.2348 8.5 15.9804 8.60536 15.7929 8.79289C15.6054 8.98043 15.5 9.23478 15.5 9.5V9.712C15.5 10.1262 15.1642 10.462 14.75 10.462C14.3358 10.462 14 10.1262 14 9.712V9.5C14 8.83696 14.2634 8.20107 14.7322 7.73223Z"
        fill="currentColor"
      />
    </svg>
  );
};
